export default __webpack_public_path__ + "images/Vector.svg";